module.exports = __webpack_public_path__ + "img/songxiaojie.3e346d8b.png";